// removed by extract-text-webpack-plugin
module.exports = {"tooltipWrapper":"_1d9U61LNmdKB-cVLVSnbyC","shareRow":"_3knXWizmgyKK9kEBiOtdwH","activeIconContainer":"_1Oq5XzKVKNYfQ1hgSKBzcU","disabled":"rRPgEkFZfUQJeGXd9mTYa","notAllowed":"_2-Ry0cptJhPOzmrA_IESp6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ActionsTooltip/ActionsTooltip.scss
// module id = 1563
// module chunks = 0